<template>
  <div class="report">
    <Drawer
      size="92%"
      :with-header="false"
      direction="btt"
      :visible.sync="status"
      :modal-append-to-body="false"
      @close="close"
    >
      <div class="cont flex">
        <div class="head flexBw">
          <div class="title">AI分析报告</div>
          <span class="iconfont tianjia" @click="close"></span>
        </div>
        <div class="aMain flexBw">
          <div class="module left">
            <div class="count">本篇内容共 {{ resultObj?.cnt || 0 }} 个汉字</div>
            <div class="legends flexBw">
              <div
                class="item flex-v"
                v-for="(item, i) in resultObj?.legends"
                :key="item.id"
              >
                <div class="score flex">
                  <span :class="['num', 'color' + i]">{{
                    item.num
                  }}</span>
                  <span :class="['per', 'color' + i]"
                    ><span :class="['bg', 'bg' + i]"></span
                    >{{ item.per }}%</span
                  >
                </div>
                <div class="name">
                  {{ item.name }}<span class="lab">(个)</span>
                </div>
              </div>
            </div>
            <LyricManager
              :txts="this.resultObj?.result?.refText || ''"
              :options="{ isShowReport: 1 }"
              v-if="status"
            />
          </div>
          <div class="module right">
            <div class="flexBw">
              <div class="mTit flex">
                <span class="iconfont weixuanzhong"></span>AI 综合诊断
                <p class="tScore" v-if="isScoreMode">{{ resultObj?.overall }}<span>分</span></p>
              </div>
              <p
                :class="[
                  'iconfont flex-center pBtn',
                  isPlaying ? 'xingzhuangjiehe2' : 'lujing1',
                ]"
                 @click="changeStatus(resultObj?.voiceUrl)"
              ></p>
            </div>
            <div class="tScoreBox flex-v">
              <img class="icon" :src="resultObj?.levelObj?.icon" alt="" />
              <p class="txt flex-center">{{ resultObj?.levelObj?.txt }}</p>
            </div>
            <div class="flexBw">
              <div class="mTit flex">
                <span class="iconfont weixuanzhong"></span>维度分值
                <Popover
                  placement="top-start"
                  title=""
                  width="300"
                  trigger="hover"
                >
                  <div class="noselect">
                    <p class="rule">
                      <span>完整度: </span
                      >根据是否能够将整篇文本从头到尾完整地朗读下来，没有遗漏或跳过任何部分;
                    </p>
                    <p class="rule">
                      <span>流利度: </span
                      >朗读时的顺畅程度，是否出现卡顿、重复或修正自己的发音;
                    </p>
                    <p class="rule">
                      <span>准确度: </span
                      >在朗读时，能准确发出每一个音节，清晰地区分平翘舌音、前后鼻音、轻声音节等;
                    </p>
                    <p class="rule">
                      <span>朗读技巧: </span
                      >是否能通过轻重音来突出文章的重点，是否通过改变语调表达句意和感情，增强语言表现力;
                    </p>
                    <p class="rule">
                      <span>情感运用: </span
                      >通过理解课文所表达的情感，在朗读时能够通过声音表达出文本的情感和意境。
                    </p>
                  </div>
                  <span slot="reference" class="iconfont a-1"></span>
                </Popover>
              </div>
              <div class="flex-center">
                <ElSwitch
                  v-model="isScoreMode"
                  active-color="#FB7C33"
                  style="margin-right: 8px"
                  @change="initChart()"
                ></ElSwitch
                >分值模式
              </div>
            </div>
            <div class="flex">
              <div id="levelChart" class="levelChart"></div>
              <div class="sBox flex-v">
                <div
                  class="sItem flexBw"
                  v-for="(val, key) in scoreObj"
                  :key="key"
                >
                  <div class="lefLab flex">
                    <p class="lab">{{ key }}：</p>
                    <span class="num">{{ isScoreMode ? val : "" }}</span>
                  </div>
                  <p class="lev" :style="{ color: colorObj[scoreLev(val)] }">
                    {{ scoreLev(val) }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Drawer>
  </div>
</template>
<script>
import { Drawer, Switch, Popover } from "element-ui";
import LyricManager from "business/LyricManager";
import audioMixin from "mixin/audio";
import Carousel from "base/carousel";
import * as echarts from "echarts/core";
import { TitleComponent, LegendComponent } from "echarts/components";
import { RadarChart } from "echarts/charts";
import { CanvasRenderer } from "echarts/renderers";
echarts.use([TitleComponent, LegendComponent, RadarChart, CanvasRenderer]);

export default {
  mixins: [audioMixin],
  components: {
    Drawer,
    Popover,
    LyricManager,
    ElSwitch: Switch,
  },
  data() {
    return {
      isGlobal: false,
      status: false,
      isScoreMode: false,
      chartData: null,
      resultObj: {},
      colorObj: { A: "#00B40A", B: "#038BEA", C: "#FFAC00", D: "#FF5C5C" },
      scoreObj: {},
    };
  },
  methods: {
    showReport() {
      this.resultObj = sessionStorage.getItem("evalReport")
        ? JSON.parse(sessionStorage.getItem("evalReport"))
        : {};
      const { phonemeScore, tone, nasal, tongue } = this.resultObj;
      this.scoreObj = {
        声调: tone,
        平翘舌: tongue,
        前后鼻音: nasal,
        音素: phonemeScore,
      };
      this.status = true;
      this.isScoreMode = false;
      setTimeout(() => {
        this.initChart();
      }, 100);
    },
    scoreLev(s = 0) {
      return s > 89 ? "A" : s > 79 ? "B" : s > 59 ? "C" : "D";
    },
    initChart() {
      const { pronunciation, fluency, skillScore, emotion, integrity } =
        this.resultObj;
      let max = Math.min(
        100,
        Math.max(pronunciation, fluency, skillScore, emotion, integrity)
      );
      this.$nextTick(() => {
        this.chartData = echarts.init(document.getElementById("levelChart"));
        const that = this;
        let option = {
          legend: {},
          radar: {
            center: ["50%", "57%"],
            radius: 110,
            nameGap: 35,
            indicator: [
              {
                name: "准确度",
                max: max || 10,
                score: pronunciation,
                level: this.scoreLev(pronunciation),
              },
              {
                name: "流利度",
                max: max || 10,
                score: fluency,
                level: this.scoreLev(fluency),
              },
              {
                name: "朗读技巧",
                max: max || 10,
                score: skillScore,
                level: this.scoreLev(skillScore),
              },
              {
                name: "情感表达",
                max: max || 10,
                score: emotion,
                level: this.scoreLev(emotion),
              },
              {
                name: "完整度",
                max: max || 10,
                score: integrity,
                level: this.scoreLev(integrity),
              },
            ].map((item) => ({
              ...item,
              color: that.colorObj[item.level] || "#FB7C33", // 提前绑定颜色
            })),
            axisName: {
              formatter: function (value, indicator) {
                let text = [];
                const level = indicator.level;
                if (level)
                  text = [
                    `{lev|${level}} ${
                      that.isScoreMode ? `{num|${indicator.score}}` : ""
                    }`,
                    `{lab|${value}}`,
                  ];
                else text = [`{lev|-}`, `{lab|${value}}`];
                return text.join("\n");
              },
              rich: {
                lev: {
                  lineHeight: 20,
                  fontSize: 24,
                  fontWeight: "bolder",
                },
                num: {
                  lineHeight: 20,
                  fontSize: 12,
                },
                lab: {
                  fontSize: 14,
                  color: "#333",
                },
              },
              align: "middle",
              nameGap: 35,
            },
            axisLine: {
              lineStyle: {
                color: "rgba(102, 102, 102, .1)",
                cap: "round",
              },
            },
            splitArea: {
              areaStyle: {
                color: "#FFFCF7",
              },
            },
            splitLine: {
              lineStyle: {
                color: "rgba(102, 102, 102, .1)",
              },
            },
          },
          series: [
            {
              type: "radar",
              symbol: "none",
              emphasis: {
                lineStyle: {
                  width: 1,
                },
              },
              data: [
                {
                  value: [
                    pronunciation,
                    fluency,
                    skillScore,
                    emotion,
                    integrity,
                  ],
                  areaStyle: {
                    color: "rgba(251, 124, 51, .3)",
                  },
                  lineStyle: {
                    color: "rgba(251, 124, 51, .3)",
                    join: "",
                    width: 0,
                  },
                },
              ],
            },
          ],
        };
        this.chartData.setOption(option);
      });
    },
    close() {
      this.status = false;
      this.globalAudio.pause();
      this.globalAudio.currentTime = 0;
    },
  },
};
</script>

<style lang="less" scoped>
@g: #00b40a;
@b: #038bea;
@y: #ffac00;
@r: #ff5c5c;
.color0 {
  color: @g;
}
.color1 {
  color: @b;
}
.color2 {
  color: @y;
}
.color3 {
  color: @r;
}
.bg0 {
  background: @g;
}
.bg1 {
  background: @b;
}
.bg2 {
  background: @y;
}
.bg3 {
  background: @r;
}
.mTit {
  font-size: 20px;
  color: #333333;
  font-weight: bold;
}
.mBox {
  background: #fffcf7;
  border-radius: 20px;
  border: 1px solid #f5eddf;
}

.cont {
  height: 100%;
  flex-direction: column;
}

.head {
  width: 100%;
  padding: 20px 40px;
  box-sizing: border-box;
  background: #fffcf7;
  cursor: pointer;
  .mTit;

  .title {
    position: relative;
    color: #333333;
    padding-left: 16px;

    &::before {
      content: "";
      width: 6px;
      height: 16px;
      background: #FB7C33;
      border-radius: 3px;
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
    }
  }

  .iconfont {
    transform: rotate(45deg);
    color: #999999;
    font-size: 20px;
  }
}

.aMain {
  padding: 2%;
  box-sizing: border-box;
  height: calc(100% - 80px);

  .module {
    overflow-y: auto;
    .mBox;
    height: 100%;
    width: 48%;
    &::-webkit-scrollbar {
      width: 0;
      height: 0;
      background: transparent;
    }
  }

  .left {
    width: 50%;
    padding: 0 1%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
  }

  .right {
    padding: 1% 2%;
    box-sizing: border-box;
  }
  .count {
    color: #666666;
    font-size: 16px;
    margin: 17px 0 24px 0;
  }

  .legends {
    height: 120px;
    background: rgba(255, 255, 255, 0.99);
    border-radius: 20px;
    border: 1px dashed rgba(251, 124, 51, 0.2);
    justify-content: space-around;
    padding: 0 5%;
    box-sizing: border-box;
    flex-shrink: 0;

    .item {
      align-items: center;

      .num {
        font-size: 30px;
      }

      .per {
        min-width: 40px;
        padding: 0 4px;
        height: 28px;
        box-sizing: border-box;
        position: relative;
        font-size: 14px;
        text-align: center;
        align-self: flex-end;
        line-height: 28px;
        margin-left: 10px;

        .bg {
          width: 100%;
          height: 100%;
          border-radius: 6px;
          position: absolute;
          top: 0;
          left: 0;
          opacity: 0.1;
        }
      }
      .name {
        color: #333333;
        font-size: 16px;
        .lab {
          font-size: 12px;
        }
      }
    }
  }

  .weixuanzhong {
    font-size: 10px;
    color: @g;
    margin-right: 10px;
  }
  .a-1 {
    font-size: 16px;
    color: @g;
    font-weight: lighter;
    margin-left: 10px;
  }
  .mTit {
    align-items: center;
  }

  .tScore {
    color: @g;
    font-size: 40px;
    margin-left: 23px;

    span {
      font-size: 24px;
      margin-left: 10px;
    }
  }

  .tScoreBox {
    justify-content: center;
    align-items: center;
    margin: -60px 0 30px;
    .icon {
      width: auto;
      height: 277px;
      object-fit: contain;
    }

    .txt {
      color: #00b40a;
      font-size: 19px;
      width: 483px;
      height: 80px;
      border-radius: 4px;
      border: 1px dashed rgba(251, 124, 51, 0.2);
      position: relative;
      margin-top: -28px;

      &::before,
      &::after {
        content: "";
        width: 24px;
        height: 21px;
        position: absolute;
        background: url("https://llss-file.langsounds.com/miniapp/7fe3e1372a289acf2eadddd18c9cef58.png")
          no-repeat;
        background-size: contain;
      }
      &::before {
        top: 12px;
        left: 12px;
      }

      &::after {
        bottom: 12px;
        right: 12px;
        transform: rotate(180deg);
      }
    }
  }

  .pBtn {
    width: 60px;
    height: 60px;
    background: #FB7C33;
    box-shadow: 0px 0 0px 5px rgba(251, 124, 51, .1);
    border-radius: 50%;
    color: #ffffff;
    font-size: 20px;
    cursor: pointer;
  }

  .levelChart {
    min-width: 60%;
    flex-shrink: 0;
    height: 350px;
    margin-top: 10px;
  }

  .sBox {
    min-width: 246px;
    height: 266px;
    background: #ffffff;
    border-radius: 4px;
    border: 1px solid #eeeeee;
    padding: 19px 20px;
    box-sizing: border-box;
    justify-content: space-between;
    margin-top: 45px;
    .sItem {
      width: 100%;
      .lefLab {
        flex: auto;
        min-height: 28px;

        .lab {
          min-width: 50%;
          text-align: right;
          font-size: 16px;
          color: #666666;
        }
        .num {
          font-size: 24px;
          color: #333333;
        }
      }

      .lev {
        font-size: 24px;
      }
    }
  }
}

.rule {
  font-size: 14px;
  line-height: 21px;
  color: #999;
  padding-bottom: 10px;

  span {
    color: #333333;
    font-weight: bold;
    white-space: nowrap;
    margin-right: 2px;
  }
}
</style>

<style lang="less">
.report .word-display {
  transform: scale(1.4);
  transform-origin: left top;
  white-space: normal;
  width: 71%;
  max-height: 100%;
  height: auto;
  padding-top: 5%;
}
</style>
